export default __webpack_public_path__ + "static/media/f_icon.316c5c84.svg";